// This is the javascript entrypoint for the promo-grid section.
// This file and all its inclusions will be processed through postcss
import '@archetype-themes/scripts/config';
import '@archetype-themes/scripts/modules/video-section';

let check_calendar = setInterval(function(){
	if(document.querySelectorAll('[data-target="calendar"]').length > 0) {
		clearInterval(check_calendar);
		console.log('finished');
		document.querySelector('[data-target="calendar"]').addEventListener('click', function(e){
			e.preventDefault();
			if(document.querySelectorAll('.calendly-inline-widget').length > 0) {
			    var element = document.querySelector('.calendly-inline-widget');
			    var headerOffset = document.querySelector('header#SiteHeader').getBoundingClientRect().height;
			    var elementPosition = element.getBoundingClientRect().top;
			    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
			  
			    window.scrollTo({
			         top: offsetPosition,
			         behavior: "smooth"
			    });
			}
		});
	}
});